import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { store } from "store";
import axios from "axios";
var EditRepeatsView = /** @class */ (function (_super) {
    tslib_1.__extends(EditRepeatsView, _super);
    function EditRepeatsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = store;
        _this.eventParticipant = store.selectedEvent.eventParticipant;
        return _this;
    }
    EditRepeatsView.prototype.routed = function () {
        store.page.title = this.$t("editRepeatsView.title");
        store.page.showTopNav = true;
    };
    Object.defineProperty(EditRepeatsView.prototype, "isValidatedForSave", {
        get: function () {
            var _a = this.eventParticipant, estimatedRepeats = _a.estimatedRepeats, repeats = _a.repeats;
            return (estimatedRepeats == null || estimatedRepeats >= 0) && (repeats == null || repeats >= 0);
        },
        enumerable: true,
        configurable: true
    });
    EditRepeatsView.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.put("eventparticipants/" + this.eventParticipant.eventParticipantId, this.eventParticipant)];
                    case 1:
                        _a.sent();
                        this.$router.push('/');
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EditRepeatsView = tslib_1.__decorate([
        Component
    ], EditRepeatsView);
    return EditRepeatsView;
}(Vue));
export default EditRepeatsView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/EditRepeatsView.vue
// module id = 59
// module chunks = 0